import { render, staticRenderFns } from "./SubscriptionOrders.vue?vue&type=template&id=242f0aba&scoped=true&"
import script from "./SubscriptionOrders.vue?vue&type=script&lang=js&"
export * from "./SubscriptionOrders.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionOrders.vue?vue&type=style&index=0&id=242f0aba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f0aba",
  null
  
)

export default component.exports